<template>
  <div
    class="expanding-insert-button"
    :class="{ open, 'always-open': alwaysOpen }"
    @click="onOpen"
  >
    <div class="eib-container" :class="{ open }">
      <div
        class="eib-expand-region"
        :class="{ open, 'always-open': alwaysOpen }"
      >
        <div @click.stop="() => {}">
          <slot v-bind="{ close: onClose }"></slot>
        </div>
      </div>
      <div
        v-if="!open || !hideCloseButton"
        class="eib-single-button-container"
        :class="{ open }"
        @click.stop="onToggleOpen"
      >
        <icon-button
          v-if="!alwaysOpen"
          :key="open"
          :class="{ open }"
          class="eib-single-button"
          size="x-small"
          :color="!open ? 'primary' : undefined"
          :icon-color="!open ? 'white' : undefined"
          :icon="open ? 'close' : 'add'"
        />
      </div>
    </div>
  </div>
</template>

<script>
import IconButton from '@/components/Common/IconButton.vue';

export default {
  name: 'ExpandingInsertButton',
  components: { IconButton },
  props: {
    alwaysOpen: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Boolean,
      default: false,
    },
    hideCloseButton: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    open: false,
  }),
  watch: {
    value: {
      handler(open) {
        this.open = open;
      },
      immediate: true,
    },
    alwaysOpen: {
      handler(open) {
        if (open) {
          this.open = true;
        }
      },
      immediate: true,
    },
  },
  methods: {
    onOpen() {
      if (this.alwaysOpen) {
        return;
      }
      this.open = true;
      this.$emit('input', this.open);
    },
    onClose() {
      if (this.alwaysOpen) {
        return;
      }
      this.open = false;
      this.$emit('input', this.open);
    },
    onToggleOpen() {
      if (this.alwaysOpen) {
        return;
      }
      this.open = !this.open;
      this.$emit('input', this.open);
    },
  },
};
</script>

<style lang="scss" scoped>
.expanding-insert-button {
  display: grid;
  grid: 'cell';
  align-items: center;
  width: 100%;
  opacity: 0;
  transition: opacity 0.2s ease-out;

  &:hover {
    opacity: 1;
  }

  &.open {
    opacity: 1;
  }

  &:not(.open) {
    cursor: pointer;
  }

  &.always-open {
    transition: none;
  }
}

.eib-container {
  grid-area: cell;
  margin: 12px 0;
}

.eib-expand-region {
  max-height: 0px;
  overflow: hidden;
  transition: max-height 0.5s ease-out;

  &.open {
    max-height: 70px;
  }

  &:not(.open) {
    border-top: 2px solid var(--v-primary-base);
  }

  &.always-open {
    transition: none;
  }
}

.eib-single-button-container {
  position: relative;
  grid-area: cell;
  height: 50%;
  &.open {
    height: 20px;
  }
}

.eib-single-button {
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 20px;
  height: 20px;
  transform: translate(-50%, 50%);
  &.open {
    height: 20px;
    transform: translate(-50%, 0);
  }
}
</style>
